function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M0 12.5C0 5.873 5.373.5 12 .5s12 5.373 12 12-5.373 12-12 12-12-5.373-12-12zm2.036 0c0 5.502 4.462 9.964 9.964 9.964 5.502 0 9.964-4.462 9.964-9.964 0-5.502-4.462-9.964-9.964-9.964-5.502 0-9.964 4.462-9.964 9.964zm13.717-4.26h1.256c.174 0 .276.198.171.34l-5.64 7.822a.85.85 0 01-1.386 0l-3.337-4.629a.215.215 0 01.174-.34h1.256c.276 0 .533.134.694.356l1.907 2.647 4.21-5.84a.853.853 0 01.695-.356z"
});

function SvgIconCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none"
  }, props), _ref);
}

export default SvgIconCheckCircle;